import { useState } from "react";
import { useModal } from "@ludens-reklame/react-modal";
import { Showcase } from "./Showcases.js";
import {
  GalleryGrid,
  ModalClose,
  ModalContent,
  ModalNav,
  ModalText,
  ModalWrapper,
} from "./styles.js";
import { RichText } from "../../internal-components/RichText.js";
import { Constrainer } from "../../internal-components/Layout.js";
import { Button } from "../../internal-components/Button.js";
import { close } from "../../icons/index.js";

interface Props {
  initialIndex: number;
  cases: Showcase[];
}

export const ShowcaseModal: React.FunctionComponent<Props> = ({
  initialIndex,
  cases,
}) => {
  const [index, setIndex] = useState<number>(initialIndex);
  const [primaryImageIndex, setPrimaryImageIndex] = useState<number>(0);
  const { despawnModal } = useModal();

  const selectedCase = cases[index];

  if (!selectedCase) {
    return null;
  }

  const images = selectedCase.images || [];
  const primaryImage = images[primaryImageIndex]?.image;

  return (
    <ModalWrapper>
      <ModalClose onClick={() => despawnModal()} aria-label="Lukk vindu">
        {close}
      </ModalClose>
      <Constrainer>
        <ModalNav>
          {index > 0 && (
            <Button $variant="tertiary" onClick={() => setIndex(index - 1)}>
              Forrige prosjekt
            </Button>
          )}
          {index + 1 < cases.length && (
            <Button
              className="next"
              $variant="tertiary"
              onClick={() => setIndex(index + 1)}
            >
              Neste prosjekt
            </Button>
          )}
        </ModalNav>
        <ModalContent>
          {selectedCase.images?.length && (
            <GalleryGrid>
              {primaryImage && (
                <img
                  src={primaryImage.transforms["w_1288"]}
                  alt={primaryImage.altText}
                />
              )}
              {selectedCase.images.map((i, k) => {
                if (!i.image || k === primaryImageIndex) {
                  return null;
                }

                return (
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setPrimaryImageIndex(k);
                    }}
                    aria-label={`Vis bilde ${i.image.altText}`}
                  >
                    <img
                      src={i.image.transforms["w_298,h_168,f_cover"]}
                      alt={i.image.altText}
                    />
                  </a>
                );
              })}
            </GalleryGrid>
          )}
          <ModalText>
            <p>Prosjekt:</p>
            <h1 className="h3">{selectedCase.title}</h1>
            {selectedCase.text && (
              <RichText
                dangerouslySetInnerHTML={{ __html: selectedCase.text }}
              />
            )}
          </ModalText>
        </ModalContent>
      </Constrainer>
    </ModalWrapper>
  );
};
